// extracted by mini-css-extract-plugin
export default {"hwaFooter":"HWAFooter_hwaFooter__Vp6CC","horzList":"HWAFooter_horzList__i9EFP"};